import { cn } from "common/utils/utils";

interface SectionedScrollableProps {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
}

const SectionedScrollable = ({
  title,
  description,
  children,
  className,
}: SectionedScrollableProps) => {
  return (
    <div className={cn("flex flex-col", className)}>
      <p className="text-[16px] font-semibold leading-[24px] tracking-[-1.5%] text-neutral-700">
        {title}
      </p>
      <p className="mt-2 text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700">
        {description}
      </p>
      {children}
    </div>
  );
};

export default SectionedScrollable;
